import { IRoleTypeService } from "../../service/role/RoleTypeService";
import { IRoleTypePositionType } from "../../model/role/RoleTypePositionType";

export default class CreateRoleTypePositionTypesInteractor {
  private roleTypeService: IRoleTypeService;

  constructor(roleTypeService) {
    this.roleTypeService = roleTypeService;
  }

  async execute(roleTypePositionTypes: IRoleTypePositionType[]) {
    return this.roleTypeService.createRoleTypePositionTypes(
      roleTypePositionTypes
    );
  }
}
